//   // import React, { useState } from "react";
//   // import "./Testimonial.css";

//   // const data = [
//   //   {
//   //     name: "Raghav Laddha",
//   //     review:
//   //       "I had Korean Garlic Bun, Dutch Chocolate Cake, and Peri Peri Paneer Pizza. They were all delicious! The atmosphere and vibes were pretty cool too.",
//   //     rating: 5,
//   //     img: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg",
//   //   },
//   //   {
//   //     name: "Raghav",
//   //     review:
//   //       "I had Korean Garlic Bun, Dutch Chocolate Cake, and Peri Peri Paneer Pizza. They were all delicious! The atmosphere and vibes were pretty cool too.",
//   //     rating: 5,
//   //     img: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg",
//   //   },
//   // ];

//   // const Testimonial = () => {
//   //   const [index, setIndex] = useState(0);

//   //   const prevSlide = () => {
//   //     setIndex((i) => (i === 0 ? data.length - 1 : i - 1));
//   //   };

//   //   const nextSlide = () => {
//   //     setIndex((i) => (i === data.length - 1 ? 0 : i + 1));
//   //   };

//   //   return (
//   //     <div className="testimonial-section">
//   //       <h1 className="title">Happy Customer Reviews</h1>

//   //       <div className="carousel-wrapper">
//   //         {/* Left Arrow */}
//   //         <button className="arrow left" onClick={prevSlide}>
//   //           &#10094;
//   //         </button>

//   //         {/* Testimonial Card */}
//   //         <div className="testimonial-card">
//   //           <div className="text-area">
//   //             <h2 className="name">{data[index].name}</h2>

//   //             <div className="stars">
//   //               {"★".repeat(data[index].rating)}
//   //             </div>

//   //             <p className="review-text">{data[index].review}</p>
//   //           </div>

//   //           <img src={data[index].img} alt="profile" className="profile-img" />
//   //         </div>

//   //         {/* Right Arrow */}
//   //         <button className="arrow right" onClick={nextSlide}>
//   //           &#10095;
//   //         </button>
//   //       </div>

//   //       {/* Dots */}
//   //       <div className="dots">
//   //         {[0, 1, 2, 3].map((dot, i) => (
//   //           <span
//   //             key={i}
//   //             className={`dot ${i === index ? "active" : ""}`}
//   //           />
//   //         ))}
//   //       </div>

//   //       {/* <h2 className="follow-text">
//   //         Follow us on <span>Instagram</span>
//   //       </h2> */}
//   //     </div>
//   //   );
//   // };

//   // export default Testimonial;


//   import React, { useState } from "react";
// import "./Testimonial.css";

// const data = [
//   {
//     name: "Raghav Laddha",
//     review:
//       "I had Korean Garlic Bun, Dutch Chocolate Cake, and Peri Peri Paneer Pizza. They were all delicious! The atmosphere and vibes were pretty cool too.",
//     rating: 5,
//     img: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg",
//   },
//   {
//     name: "Raghav",
//     review:
//       "I had Korean Garlic Bun, Dutch Chocolate Cake, and Peri Peri Paneer Pizza. They were all delicious! The atmosphere and vibes were pretty cool too.",
//     rating: 5,
//     img: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg",
//   },
// ];

// const Testimonial = () => {
//   const [index, setIndex] = useState(0);

//   const prevSlide = () => {
//     setIndex((i) => (i === 0 ? data.length - 1 : i - 1));
//   };

//   const nextSlide = () => {
//     setIndex((i) => (i === data.length - 1 ? 0 : i + 1));
//   };

//   return (
//     <div className="testimonial-section">
//       <h1 className="title">Happy Customer Reviews</h1>

//       <div className="carousel-wrapper">
//         {/* Left Arrow */}
//         <button className="arrow left" onClick={prevSlide}>
//           &#10094;
//         </button>

//         {/* Testimonial Card */}
//         <div className="testimonial-card">
//           <div className="text-area">

//             {/* Name + Stars Row */}
//             <div className="name-stars">
//               <h2 className="name">{data[index].name}</h2>
//               <div className="stars">{"★".repeat(data[index].rating)}</div>
//             </div>

//             <p className="review-text">{data[index].review}</p>
//           </div>

//           <img src={data[index].img} alt="profile" className="profile-img" />
//         </div>

//         {/* Right Arrow */}
//         <button className="arrow right" onClick={nextSlide}>
//           &#10095;
//         </button>
//       </div>

//       {/* Dots */}
//       <div className="dots">
//         {data.map((_, i) => (
//           <span
//             key={i}
//             className={`dot ${i === index ? "active" : ""}`}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Testimonial;



import React, { useState } from "react";
import "./Testimonial.css";

const data = [
  // {
  //   name: "Raghav Laddha",
  //   review:
  //     "I had Korean Garlic Bun, Dutch Chocolate Cake, and Peri Peri Paneer Pizza. They were all delicious! The atmosphere and vibes were pretty cool too.",
  //   rating: 5,
  //   img: "https://bakelore.com/images/Raghav-Laddha.png",
  //   side: "right", // image on the right (slide 1)
  // },
  // {
  //   name: "Manmith Reddy",
  //   review:
  //     "Good food, ambience and service. Felt like a modernized bakery. Haleem Chicken 65 bun was good. Tres Leches is good. Chocolate cake is good.",
  //   rating: 5,
  //   img: "https://bakelore.com/images/Manmith-Reddy.png",
  //   side: "left", // image on the left (slide 2)
  // },

   {
  name: "Logesh Sridhar",
  review:
    "The biscuits are unique, and the plum cake is fresh and tastes very good. The price is a little on the higher side, but overall it is one of the finest destinations for cake and baked-goods lovers.",
  rating: 5,
  img: "https://skyhitmedia.com/images/review-image-services-2.png",
  side: "right",
},
{
  name: "Vivek Tumulu",
  review:
    "Good food and good ambience. I really liked the brownie, hot chocolate, and garlic bread.",
  rating: 5,
  img: "https://skyhitmedia.com/images/review-image-services-3.png",
  side: "left",
},
{
  name: "Anusha Mathew",
  review:
    "Bakelore is one of my most favourite cafés in Hyderabad. I am a regular customer because of the positive atmosphere and friendly team members who are very down to earth. Especially Mr. Priyansh, who always welcomes customers with a gentle smile. I remember the delicious pizza he cooked for me. He maintains great contact with customers and understands their needs well. The café is super clean and always has good music. Highly recommended!",
  rating: 5,
  img: "https://skyhitmedia.com/images/review-image-services-1.png",
  side: "right",
},

{
  name: "Akash Fernando",
  review:
    "Food was really good, especially the Butter Chicken Bun. It was a great suggestion by Priyesh.",
  rating: 5,
  img: "https://skyhitmedia.com/images/review-image-services-3.png",
  side: "left",
},

{
  name: "Vishali S",
  review:
    "The cake was extremely fresh, tempting, and truly irresistible—it keeps calling us back again. The hospitality was excellent.",
  rating: 5,
  img: "https://skyhitmedia.com/images/review-image-services-1.png",
  side: "right",
},
{
  name: "Rishitha",
  review:
    "Excellent work! Thanks for the smoothie suggestions—they were refreshing and perfectly recommended.",
  rating: 5,
  img: "https://skyhitmedia.com/images/review-image-services-2.png",
  side: "left",
},

];

const Testimonial = () => {
  const [index, setIndex] = useState(0);

  const prevSlide = () => {
    setIndex((i) => (i === 0 ? data.length - 1 : i - 1));
  };

  const nextSlide = () => {
    setIndex((i) => (i === data.length - 1 ? 0 : i + 1));
  };

  return (
    <div className="testimonial-section">
      <h1 className="title">Happy Customer Reviews</h1>

      <div className="carousel-wrapper">
        {/* Left Arrow */}
        <button className="arrow left" onClick={prevSlide}>
          &#10094;
        </button>

        {/* Testimonial Card */}
        <div className="testimonial-card">

          {/* IF IMAGE ON LEFT */}
          {data[index].side === "left" && (
            <img src={data[index].img} alt="profile" className="profile-img left-img" />
          )}

          {/* TEXT AREA */}
          <div className="text-area">
            <div className="name-stars">
              <h2 className="name">{data[index].name}</h2>
              <div className="stars">{"★".repeat(data[index].rating)}</div>
            </div>

            <p className="review-text">{data[index].review}</p>
          </div>

          {/* IF IMAGE ON RIGHT */}
          {data[index].side === "right" && (
            <img src={data[index].img} alt="profile" className="profile-img right-img" />
          )}
        </div>

        {/* Right Arrow */}
        <button className="arrow right" onClick={nextSlide}>
          &#10095;
        </button>
      </div>

      {/* Dots */}
      <div className="dots">
        {data.map((_, i) => (
          <span key={i} className={`dot ${i === index ? "active" : ""}`} />
        ))}
      </div>
    </div>
  );
};

export default Testimonial;
